window.isMobile = window.innerWidth <= 640;
window.$ = window.jQuery = $;

// core-js pollyfills our bundle based on what's defined in .browserslistrc
// regenerator-runtime is a dependency of core-js. see
// https://github.com/zloirock/core-js#babel for more info.
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'classlist-polyfill';
import 'custom-event-polyfill';
import 'intl-tel-input/build/js/utils.js';
import 'javascripts/behaviors';
import 'javascripts/components';
import 'javascripts/modal';
import 'javascripts/offCanvas';
import 'javascripts/styles';
import 'javascripts/vendor/refile';
import 'jquery-ujs';
import 'parsleyjs';
import fakeStripe from 'javascripts/utils/fakeStripe';
import fakePlaid from 'javascripts/utils/fakePlaid';
import requireAll from 'javascripts/utils/requireAll';

if (window.useFakeStripe) {
  window.Stripe = fakeStripe;
}

if (window.useFakePlaid) {
  window.Plaid = fakePlaid;
}

if (process.env.NODE_ENV !== 'production') {
  window.MockDate = require('mockdate');
}

requireAll(
  require.context(
    '../../assets/javascripts',
    true,
    /(experiments|utils)\/.*\.js/
  )
);
